export default {
  state: () => ({
    notifications: [],
    notificationsShown: false,
    unreadNotifications: false,
  }),

  getters: {
    notifications: s => s.notifications,
    notificationsShown: s => s.notificationsShown,
    unreadNotifications: s => s.unreadNotifications,
  },

  mutations: {
    toggleNotifications(state) {
      state.notificationsShown = !state.notificationsShown
      localStorage.setItem('nova.mainMenu.open', state.notificationsShown)
    },
    addNotification(state, notification) {
      // Add notification to the beginning of the array
      state.notifications.unshift(notification)
      // Increment unread count
      state.unreadNotifications = (state.unreadNotifications || 0) + 1
      // Keep only the latest 100 notifications
      if (state.notifications.length > 100) {
        state.notifications = state.notifications.slice(0, 100)
      }
    },
    updateUnreadCount(state, count) {
      state.unreadNotifications = count
    },
  },

  actions: {
    async fetchNotifications({ state }) {
      const {
        data: { notifications, unread },
      } = await Nova.request().get(`/nova-api/nova-notifications`)

      state.notifications = notifications
      state.unreadNotifications = unread
    },

    async markNotificationAsUnread({ state, dispatch }, id) {
      await Nova.request().post(`/nova-api/nova-notifications/${id}/unread`)
      dispatch('fetchNotifications')
    },

    async markNotificationAsRead({ state, dispatch }, id) {
      await Nova.request().post(`/nova-api/nova-notifications/${id}/read`)
      // Update the notification in the list
      const notification = state.notifications.find(n => n.id === id)
      if (notification) {
        notification.read_at = new Date().toISOString()
      }
      // Recalculate unread count
      state.unreadNotifications = state.notifications.filter(n => !n.read_at).length
    },

    async deleteNotification({ state, dispatch }, id) {
      await Nova.request().delete(`/nova-api/nova-notifications/${id}`)
      // Remove notification from the list
      const index = state.notifications.findIndex(n => n.id === id)
      if (index !== -1) {
        const wasUnread = !state.notifications[index].read_at
        state.notifications.splice(index, 1)
        // Update unread count if the deleted notification was unread
        if (wasUnread) {
          state.unreadNotifications = Math.max(0, (state.unreadNotifications || 0) - 1)
        }
      }
    },

    async deleteAllNotifications({ state, dispatch }, id) {
      await Nova.request().delete(`/nova-api/nova-notifications`)
      state.notifications = []
      state.unreadNotifications = 0
    },

    async markAllNotificationsAsRead({ state, dispatch }, id) {
      await Nova.request().post(`/nova-api/nova-notifications/read-all`)
      // Mark all notifications as read
      const now = new Date().toISOString()
      state.notifications.forEach(notification => {
        notification.read_at = notification.read_at || now
      })
      state.unreadNotifications = 0
    },
  },
}
